import { defineComponent as _defineComponent } from 'vue'
import { useUserStore } from "@/stores/user.store";
import { computed, ref } from "vue";
import * as appInfo from "@/lib/appInfo";
import dayjs from "dayjs";
import useApiAppInfo from "@/composables/useApiAppInfo";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileView',
  setup(__props, { expose: __expose }) {
  __expose();

const userStore = useUserStore();
const { apiAppInfo } = useApiAppInfo();

const emailAddress = ref(userStore.self?.email);
const phoneNumber = ref(userStore.self?.contactPhone);
const fullName = ref(userStore.self?.name);
const showApi = ref(false);
const showMenu = ref();

const initialsFromString = computed(() => {
  const names = fullName.value?.split(" ") || [];
  const firstInitial = names[0]?.charAt(0).toUpperCase();
  if (names.length === 1) {
    return firstInitial || "";
  } else {
    const lastInitial = names[names.length - 1].charAt(0).toUpperCase();
    return `${firstInitial}${lastInitial}`;
  }
});


const __returned__ = { userStore, apiAppInfo, emailAddress, phoneNumber, fullName, showApi, showMenu, initialsFromString, get appInfo() { return appInfo }, get dayjs() { return dayjs } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})